import React, { ReactNode, useMemo } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

interface NotFoundContextProps {
  notFound: boolean;
}

const NotFoundContext = React.createContext<NotFoundContextProps | null>(null);

interface NotFoundProviderProps {
  routes: string[];
  children: ReactNode;
}

export const NotFoundProvider: React.FC<NotFoundProviderProps> = ({ routes, children }) => {
  const { pathname } = useLocation();

  const value = useMemo<NotFoundContextProps>(
    () => ({
      notFound: !routes.some((pattern) => matchPath(pattern, pathname) !== null),
    }),
    [routes, pathname],
  );

  return <NotFoundContext.Provider value={value}>{children}</NotFoundContext.Provider>;
};

export const useNotFound = () => {
  const context = React.useContext(NotFoundContext);
  if (!context) {
    throw new Error('useNotFound must be used within a NotFoundProvider');
  }
  return context;
};
